export default __webpack_public_path__ + "static/media/guide_icon_white.31124c22.svg";